import { render, staticRenderFns } from "./h5Header.vue?vue&type=template&id=baea8b54&scoped=true&"
import script from "./h5Header.vue?vue&type=script&lang=js&"
export * from "./h5Header.vue?vue&type=script&lang=js&"
import style0 from "./h5Header.vue?vue&type=style&index=0&id=baea8b54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baea8b54",
  null
  
)

export default component.exports